import React from 'react'
import mainImg from '../../assets/landing/clients/main.png'
import logo1 from '../../assets/landing/clients/01-Aveva-mono.png'
import logo2 from '../../assets/landing/clients/02-Chub-mono.png'
import logo3 from '../../assets/landing/clients/03-corteva-mono.png'
import logo4 from '../../assets/landing/clients/06-factset-mono.png'
import logo5 from '../../assets/landing/clients/04-ea-mono.png'
import logo6 from '../../assets/landing/clients/05-f5-mono.png'
import logo7 from '../../assets/landing/clients/07-mass-mono.png'
import logo8 from '../../assets/landing/clients/08-mouri-mono.png'
import logo9 from '../../assets/landing/clients/09-rimini-mono.png'
import logo10 from '../../assets/landing/clients/10-spglobl-mono.png'
import logo11 from '../../assets/landing/clients/11.png'
import logo12 from '../../assets/landing/clients/12.png'
import logo13 from '../../assets/landing/clients/13.png'
import logo14 from '../../assets/landing/clients/14.png'
import logo15 from '../../assets/landing/clients/15.png'

import clientBgVideo from '../../assets/landing/clients-bg.mp4'


const Clients = () => {
  return (
    <div className='h-fit relative w-full overflow-hidden'>
       <video
        className="absolute  top-0 left-0 w-full h-full object-cover filter brightness-[60%]"
        src={clientBgVideo}
        autoPlay
        loop
        muted
      ></video>
        {/* <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-50"></div> */}
      <div className='h-fit z-10 py-16 md:py-24 px-6 md:pl-12 md:pr-0 lg:pl-20 flex flex-col gap-y-12'>
      <h1 className='text-[#fff] text-4xl md:text-5xl font-mosk300 drop-shadow-lg'>
        Our <span className='font-mosk700'>Trust Fosters</span> With....
      </h1>

          <div className='hidden md:flex items-center ' >
            <div className='flex flex-col gap-y-12 w-full lg:w-[90%] 3xl:w-[70%] mx-auto' >
              <div className='grid grid-cols-5 gap-y-8 lg:gap-y-4 3xl:gap-y-6 gap-x-12 items-center justify-center' >
                <img data-aos="fade-up" className='max-h-[2rem] 3xl:max-h-[4rem] 5xl:max-h-[5rem] mx-auto' src={logo1} alt="" />
                <img data-aos="fade-up" className='max-h-[2rem] 3xl:max-h-[3rem]  5xl:max-h-[4rem] mx-auto' src={logo2} alt="" />
                <img data-aos="fade-up" className='max-h-[3rem] 3xl:max-h-[5rem]  5xl:max-h-[6rem] mx-auto' src={logo3} alt="" />
                <img data-aos="fade-up" className='max-h-[2rem] 3xl:max-h-[4rem]  5xl:max-h-[5rem] mx-auto' src={logo4} alt="" />
                <img data-aos="fade-up" className='max-h-[4rem] 3xl:max-h-[6rem]  5xl:max-h-[7rem] mx-auto' src={logo7} alt="" />
                <img data-aos="fade-up" className='max-h-[4rem] 3xl:max-h-[8rem]  5xl:max-h-[8rem] mx-auto' src={logo5} alt="" />
                <img data-aos="fade-up" className='max-h-[3rem] 3xl:max-h-[6rem]  5xl:max-h-[7rem] mx-auto' src={logo11} alt="" />
                <img data-aos="fade-up" className='max-h-[10rem] 3xl:max-h-[16rem]  5xl:max-h-[20rem] mx-auto' src={logo12} alt="" />
                <img data-aos="fade-up" className='max-h-[3rem] 3xl:max-h-[5rem]  5xl:max-h-[6rem] mx-auto' src={logo14} alt="" />
                <img data-aos="fade-up" className='max-h-[4rem] 3xl:max-h-[8rem]  5xl:max-h-[8rem] mx-auto' src={logo6} alt="" />
                <img data-aos="fade-up" className='max-h-[3rem] 3xl:max-h-[6rem]  5xl:max-h-[7rem] mx-auto' src={logo15} alt="" />
                <img data-aos="fade-up" className='max-h-[3rem] 3xl:max-h-[5rem]  5xl:max-h-[6rem] mx-auto' src={logo9} alt="" />
                <img data-aos="fade-up" className='max-h-[5rem] 3xl:max-h-[7rem]  5xl:max-h-[9rem] mx-auto' src={logo8} alt="" />
                <img data-aos="fade-up" className='max-h-[4rem] 3xl:max-h-[7rem]  5xl:max-h-[8rem] mx-auto' src={logo10} alt="" />
                <img data-aos="fade-up" className='max-h-[3rem] 3xl:max-h-[5rem]  5xl:max-h-[6rem] mx-auto' src={logo13} alt="" />
              </div>
              {/* <div className='grid grid-cols-5 gap-x-12 items-center'>

              </div>
              <div className='grid grid-cols-5 gap-12 items-center justify-center ' >
              </div> */}
            </div>

            {/* <img data-aos="zoom-in" className=' w-[35%] relative left-[-5vw]' src={mainImg} alt="" /> */}

          </div>

          <div className='md:hidden grid grid-cols-3 gap-4 items-center' >
                <img data-aos="fade-up"  className='mx-auto max-h-[3rem]' src={logo1} alt="" />
                <img data-aos="fade-up" className='mx-auto max-h-[4rem]' src={logo2} alt="" />
                <img data-aos="fade-up" className='mx-auto max-h-[4rem]' src={logo3} alt="" />
                <img data-aos="fade-up" className='mx-auto max-h-[3rem]' src={logo4} alt="" />
                <img data-aos="fade-up" className='mx-auto max-h-[3rem]' src={logo7} alt="" />
                <img data-aos="fade-up" className='mx-auto' src={logo11} alt="" />
                <img data-aos="fade-up" className='mx-auto max-h-[3rem]' src={logo14} alt="" />
                <img data-aos="fade-up" className='mx-auto  max-h-[3rem]' src={logo9} alt="" />
                <img data-aos="fade-up" className='mx-auto  max-h-[3rem]' src={logo10} alt="" />
                <img data-aos="fade-up" className='mx-auto  max-h-[3rem]' src={logo13} alt="" />
                <img data-aos="fade-up" className='mx-auto  max-h-[5rem]' src={logo8} alt="" />
                <img data-aos="fade-up" className='mx-auto  max-h-[3rem]' src={logo15} alt="" />
                <img data-aos="fade-up" className='mx-auto max-h-[3rem]' src={logo5} alt="" />
                <img data-aos="fade-up" className='mx-auto max-h-[7rem]' src={logo12} alt="" />
                <img data-aos="fade-up" className='mx-auto max-h-[3rem]' src={logo6} alt="" />
          </div>

      </div>
    </div>
  )
}

export default Clients
